import React, { useEffect, useState } from "react";
import Input from "../../../../../Core/Fields/Floating/Input";
import Button from "../../../../../Core/Button/Button";

const EditItemModal = ({
    show,
    onClose,
    itemDataReal,
}) => {
    const [itemData, setItemData] = useState({});

    useEffect(() => {
        setItemData(itemDataReal || {});
    }, [itemDataReal]);

    if (!show || !itemData || Object.keys(itemData).length === 0) return null;

    console.log(itemData, "itemData");

    return (
        <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Item Details</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body ">
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="item_code"
                                    label="Item Code"
                                    readOnly
                                    value={itemData?.item?.item_code}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="item_name"
                                    label="Item Name"
                                    readOnly
                                    value={itemData?.item?.item_name}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="item_group"
                                    label="Category"
                                    readOnly
                                    value={itemData?.item?.item_group}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="custom_category"
                                    label="Sub Category"
                                    readOnly
                                    value={itemData?.item?.custom_category}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        {/* <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="batch_id"
                                    label="Batch ID"
                                    readOnly
                                    value={itemData?.item?.batch_id}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="has_batch_no"
                                    label="Has Batch No"
                                    readOnly
                                    value={itemData?.item?.has_batch_no ? "Yes" : "No"}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="has_serial_no"
                                    label="Has Serial No"
                                    readOnly
                                    value={itemData?.item?.has_serial_no ? "Yes" : "No"}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="serial_no"
                                    label="Serial No"
                                    readOnly
                                    value={itemData?.item?.serial_no}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div> */}

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="quantity"
                                    label="Quantity"
                                    readOnly
                                    value={itemData?.quantity}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="uom"
                                    label="UOM"
                                    readOnly
                                    value={itemData?.item?.stock_uom}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="buying_price"
                                    label="Rate"
                                    readOnly
                                    value={itemData?.item?.selling_price}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            {console.log("amount is here oamout ",itemData)}
                            <div className="col-6">
                                <Input
                                    id="selling_price"
                                    label="Amount"
                                    readOnly
                                    value={itemData?.amount}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        {/* <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="standard_rate"
                                    label="Standard Rate"
                                    readOnly
                                    value={itemData?.item?.standard_rate}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="stock_uom"
                                    label="Stock UOM"
                                    readOnly
                                    value={itemData?.item?.stock_uom}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div> */}

                        {/* <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="manufacturing_date"
                                    label="Manufacturing Date"
                                    readOnly
                                    value={itemData?.item?.manufacturing_date}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="expiry_date"
                                    label="Expiry Date"
                                    readOnly
                                    value={itemData?.item?.expiry_date || "N/A"}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-12">
                                <Input
                                    id="description"
                                    label="Description"
                                    readOnly
                                    value={itemData?.item?.description}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div> */}
                    </div>

                    <div className="modal-footer">
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName=""
                            iconSize={12}
                            onClick={onClose}                                                >
                           Close
                        </Button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditItemModal;